import React from "react";
import style from "./style.module.css";

export interface IAckGroup {
    groupName: string;
    members: string[];
}

interface IAckGroupProps {
    group: IAckGroup;
}

export function AckGroup(props: IAckGroupProps) {
    return (
        <section className={style.ackGroup}>
            <h4 className={style.groupName}>{props.group.groupName}</h4>
            {
                props.group.members.map((m: string) => {
                    return <span key={m} className={style.member}>{m}</span>;
                })
            }
        </section>
    )
}